import { supabase } from "@/utils/supabase";

const FUNCTIONS_URL = `${process.env.VUE_APP_SUPABASE_URL}/functions/v1`;

// Edge Function 호출 (JWT 인증) — TwitchApi.callFn과 동일 패턴.
//  platform_oauth는 토큰 테이블이라 클라 직접 write 금지(42501) → 채널 저장/해제도 Edge(service role) 경유.
//  서버에서 app_metadata.is_admin 검증(관리자 전용).
async function callFn(path, body) {
  const {
    data: { session },
  } = await supabase.auth.getSession();
  if (!session) throw new Error("E_NOT_LOGGED_IN");

  const res = await fetch(`${FUNCTIONS_URL}${path}`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      apikey: process.env.VUE_APP_SUPABASE_KEY,
      Authorization: `Bearer ${session.access_token}`,
    },
    body: JSON.stringify(body || {}),
  });
  const json = await res.json().catch(() => ({}));
  if (!res.ok) {
    throw Object.assign(new Error(json.message || "E_REQUEST_FAILED"), { detail: json });
  }
  return json;
}

export default {
  // 관리자: relay 대상 채널명 저장 (provider='chzzk_relay'). 남의 채널을 게이트웨이로 읽기 위한 등록.
  async connect(channelName) {
    return await callFn("/signaling/chzzk/relay/connect", { channelName });
  },
  // relay 해제 — chzzk_relay 행 삭제.
  async disconnect() {
    return await callFn("/signaling/chzzk/relay/disconnect");
  },
};
